var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40",
    width: 135,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 31.8,
    y1: 896.71,
    x2: 15.02,
    y2: 913.49,
    gradientTransform: "translate(-10 -888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.83,
    y1: 908,
    x2: 19.64,
    y2: 908,
    gradientTransform: "translate(-10 -888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.82,
    y1: 910.29,
    x2: 12.06,
    y2: 933.04,
    gradientTransform: "translate(-10 -888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.3,
    y1: 888.18,
    x2: 27.46,
    y2: 898.34,
    gradientTransform: "translate(-10 -888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130 .8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H5A4.2 4.2 0 0 1 .8 35V5A4.2 4.2 0 0 1 5 .8h125m0-.8H5a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.14 21.75A4.26 4.26 0 1 0 72.41 26a4.19 4.19 0 0 0-4.13-4.25Zm0 6.83a2.58 2.58 0 1 1 2.39-2.75.91.91 0 0 1 0 .17 2.46 2.46 0 0 1-2.34 2.58Zm-9.32-6.83A4.26 4.26 0 1 0 63.09 26 4.19 4.19 0 0 0 59 21.75Zm0 6.83a2.58 2.58 0 1 1 2.39-2.75.91.91 0 0 1 0 .17 2.46 2.46 0 0 1-2.34 2.58Zm-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.45 4.45 0 0 1-3.34 1.32 4.8 4.8 0 1 1 0-9.6A4.65 4.65 0 0 1 51 20.14l1.27-1.27a6.29 6.29 0 0 0-4.53-1.82 6.61 6.61 0 0 0-.51 13.21h.51a5.84 5.84 0 0 0 6.17-6.08 7 7 0 0 0-.09-1.12Zm45.31 1.4a3.92 3.92 0 0 0-7.65 1.28 2.26 2.26 0 0 0 0 .26 4.23 4.23 0 0 0 7.76 2.37l-1.45-1a2.42 2.42 0 0 1-2.09 1.17 2.14 2.14 0 0 1-2.06-1.29l5.69-2.35Zm-5.8 1.42a2.35 2.35 0 0 1 2.18-2.49 1.64 1.64 0 0 1 1.57.91ZM82.63 30h1.87V17.5h-1.87Zm-3.06-7.3h-.07a3 3 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.87 2.87 0 0 0 2.24-1h.07v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.15-1.51l-1.62.67A4 4 0 0 0 77.3 34c2.19 0 4-1.29 4-4.43V22h-1.73Zm-2.15 5.88a2.58 2.58 0 0 1 0-5.15 2.38 2.38 0 0 1 2.28 2.49V26a2.38 2.38 0 0 1-2.17 2.57Zm24.39-11.08h-4.48V30h1.87v-4.74h2.61a3.89 3.89 0 1 0 .56-7.76 5.23 5.23 0 0 0-.56 0Zm0 6H99.2v-4.26h2.65a2.14 2.14 0 0 1 0 4.28Zm11.54-1.79a3.49 3.49 0 0 0-3.35 1.91l1.65.69a2.06 2.06 0 0 1 3.71.67v.15a4.14 4.14 0 0 0-1.95-.48c-1.78 0-3.6 1-3.6 2.82a2.89 2.89 0 0 0 3 2.76h.09a2.64 2.64 0 0 0 2.42-1.23h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46Zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.34 2-1.34a3.38 3.38 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 2ZM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.33 7.58-1.9 4.21h2L125.82 22Zm-16.8 8h1.86V17.5h-1.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 7.54a2 2 0 0 0-.44 1.4v22.12a1.94 1.94 0 0 0 .47 1.4l.07.08L22.9 20.15v-.3L10.51 7.47Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 24.28-4.1-4.13v-.3l4.1-4.13.09.06L32 18.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12 24.22 22.9 20 10.44 32.46a1.62 1.62 0 0 0 2.07.07l14.61-8.31",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.12 15.78-14.61-8.3a1.6 1.6 0 0 0-2.07.06L22.9 20Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 24.13-14.49 8.25a1.65 1.65 0 0 1-2 0l-.07.07.07.08a1.65 1.65 0 0 0 2 0l14.61-8.31Z",
    style: {
      isolation: "isolate",
      opacity: 0.20000000298023224
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44 32.32a2 2 0 0 1-.44-1.41v.15a1.94 1.94 0 0 0 .47 1.4l.07-.07ZM32 21.3l-5 2.83.09.09L32 21.44A1.74 1.74 0 0 0 33.06 20 1.86 1.86 0 0 1 32 21.3Z",
    style: {
      isolation: "isolate",
      opacity: 0.11999999731779099
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51 7.62 32 18.7a1.86 1.86 0 0 1 1.06 1.3A1.74 1.74 0 0 0 32 18.56L12.51 7.48C11.12 6.68 10 7.34 10 8.94v.15c0-1.6 1.12-2.26 2.51-1.47Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.15 12.85V6.76H43a2.9 2.9 0 0 1 3.08 3 2.9 2.9 0 0 1-3.08 3Zm.78-.75H43a2.3 2.3 0 1 0 .3-4.59h-1.37ZM47.18 12.85V6.76H48v6.09ZM51.07 13a2.32 2.32 0 0 1-1.3-.43 2 2 0 0 1-.83-1.22l.72-.29a1.61 1.61 0 0 0 .52.85 1.32 1.32 0 0 0 .89.34 1.44 1.44 0 0 0 .87-.26.87.87 0 0 0 .36-.73 1 1 0 0 0-.36-.79A3.9 3.9 0 0 0 50.8 10a3.07 3.07 0 0 1-1.23-.66 1.39 1.39 0 0 1-.41-1 1.51 1.51 0 0 1 .52-1.14A1.91 1.91 0 0 1 51 6.62a2 2 0 0 1 1.26.38 1.7 1.7 0 0 1 .62.85l-.71.29a1 1 0 0 0-.38-.53 1.16 1.16 0 0 0-.79-.24 1.25 1.25 0 0 0-.77.25.78.78 0 0 0-.31.63.7.7 0 0 0 .29.57 2.55 2.55 0 0 0 .86.42c.3.1.55.19.75.28a3.46 3.46 0 0 1 .62.36 1.46 1.46 0 0 1 .46.56 1.73 1.73 0 0 1 .16.78 1.67 1.67 0 0 1-.18.79 1.4 1.4 0 0 1-.49.56 2.59 2.59 0 0 1-.65.31 2.62 2.62 0 0 1-.67.12ZM55 12.85h-.8V6.76h2.07a1.89 1.89 0 0 1 1.34.51 1.77 1.77 0 0 1 .1 2.5l-.1.1a1.89 1.89 0 0 1-1.34.51H55Zm0-3.22h1.31a1 1 0 0 0 .79-.33 1 1 0 0 0 0-1.41 1 1 0 0 0-.79-.33H55ZM64.19 12.06a3.17 3.17 0 0 1-4.47 0 3.12 3.12 0 0 1-.89-2.26 3.1 3.1 0 0 1 .89-2.25 3.14 3.14 0 0 1 4.44 0 3.11 3.11 0 0 1 .9 2.25 3.12 3.12 0 0 1-.87 2.26Zm-3.89-.51a2.35 2.35 0 0 0 3.31 0 2.42 2.42 0 0 0 .67-1.75 2.33 2.33 0 0 0-4-1.75 2.35 2.35 0 0 0-.68 1.74 2.43 2.43 0 0 0 .7 1.76ZM66.15 12.85V6.76h.95l3 4.73V6.76h.78v6.09H70l-3.1-5v5ZM72.24 12.85V6.76H73v6.09ZM74.42 12.85V6.76h2.2a1.78 1.78 0 0 1 1.24.47 1.55 1.55 0 0 1 .52 1.19 1.28 1.28 0 0 1-.22.76 1.46 1.46 0 0 1-.6.5 1.62 1.62 0 0 1 .74.52 1.44 1.44 0 0 1 .29.87 1.62 1.62 0 0 1-.59 1.28 1.89 1.89 0 0 1-1.3.5Zm.78-3.48h1.42a1 1 0 0 0 1-.94.92.92 0 0 0-.26-.63.84.84 0 0 0-.68-.29H75.2Zm0 2.73h1.58a1 1 0 0 0 .73-.32 1 1 0 0 0 .28-.69 1 1 0 0 0-.29-.68 1 1 0 0 0-.76-.31H75.2ZM79.68 12.85V6.76h.78v5.34h2.64v.75ZM87.5 7.51h-2.77v1.93h2.5v.73h-2.5v1.93h2.77v.75H84V6.76h3.5ZM89.91 12.85l2.3-6.09h.88l2.3 6.09h-.87l-.58-1.65h-2.56l-.6 1.65Zm1.73-2.38h2l-1-2.75Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".20000000298023224px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.9db81245.svg";
export { ForwardRef as ReactComponent };